<template>
  <!-- 白邊改為底色 -->
  <v-app :style="{ backgroundColor: $store.state.questM.questBackColor }">
    <!--置中/增加padding白邊 -->
    <div class="app_center pa-4 pa-sm-6" style="line-height: 1.7">
      <!-- 限制內容顯示最大寬度 -->
      <router-view style="max-width: 960px" />
    </div>
  </v-app>
</template>

<script>
// import { changeHue } from './utils/color'
import zhConfig from '../zh.config'
const loginMode = zhConfig.loginMode
const initDetailLogic = require('./mode/' + loginMode + '/app').default.initDetailLogic

export default {
  async created() {
    // 是否直接導到感謝頁面
    let directPage = this.$route.query.directPage
    // 從 url parameter 取得問卷 Id
    let questSysId = this.$route.query.questSysId
    // 把 userToken 存入 store，並指定給變數 userToken
    let userToken = this.$route.query.UserToken
    this.$store.state.userToken = userToken = userToken === undefined ? '' : userToken
    // 把 questSysId 存入 store
    this.$store.state.questM.questSysId = questSysId

    let query = { questSysId: this.$store.state.questM.questSysId }
    // 讓使用這進入 Loading Page
    this.$router.push({ name: 'Loading', query })

    try {
      // 起始回答問卷網頁 App
      await this.$store.dispatch('initApp')
      let questM = this.$store.state.questM
      window.console.log('questM:')
      window.console.log(questM)
      // 如果設定要導向至感謝頁，就直接跳到感謝頁
      if (directPage === 'Thank') {
        this.$router.push({
          name: 'Thank',
          query: {
            questSysId: this.$store.state.questM.questSysId,
            directPage: 'Thank',
          },
        })
        return
      }
      // 判斷是否超出日期區間
      let timeStart = new Date(questM.questDateStart).getTime()
      let timeEnd = new Date(questM.questDateEnd).getTime()
      let timeNow = Date.now()
      let Expired = timeStart > timeNow || timeEnd + 86400000 < timeNow

      // 判斷名額是否已滿
      let fulled = questM.questMaxNum != null && questM.questMaxNum <= questM.questNowNum

      // 判斷是否可以顯示
      if (questM.isVisible !== '01') {
        // 1. 是否公開 isVisible
        this.$router.push({ name: 'Private', query })
      } else if (Expired) {
        // 2. 是否於可顯示之日期區間
        this.$router.push({ name: 'Expired', query })
      } else if (fulled) {
        // 3. 判斷是否有設定填寫名額，且填寫人數已額滿
        this.$router.push({ name: 'Fulled', query })
      } else {
        initDetailLogic()
        // 跳至回答頁面
        this.$router.push({ name: 'Answer', query })
      }
    } catch (err) {
      window.console.error(err)
      this.$store.state.errMessage = err.toString()
      this.$router.push({ name: 'ErrorPage', query })
    }

    // [Debug]
    // window.console.log('timeStart: ' + timeStart)
    // window.console.log('timeEnd: ' + timeEnd)
    // window.console.log('Expired: ' + Expired)
    // window.console.log('fulled: ' + fulled)
    // window.console.log('isVisible: ' + questM.isVisible)

    /*
    this.$store
      .dispatch('initApp')
      .then(res => {
        window.console.log('res.questM')
        window.console.log(res.questM)
        // 如果設定要導向至感謝頁，就直接跳到感謝頁
        if (directPage === 'Thank') {
          this.$router.push({
            name: 'Thank',
            query: {
              questSysId: this.$store.state.questM.questSysId,
              directPage: 'Thank'
            }
          })
          return
        }
        // [Debug]
        // window.console.log(res)
        // 判斷是否超出日期區間
        let timeStart = new Date(res.questM.questDateStart).getTime()
        let timeEnd = new Date(res.questM.questDateEnd).getTime()
        let timeNow = Date.now()
        let Expired = timeStart > timeNow || timeEnd + 86400000 < timeNow

        // 判斷名額是否已滿
        let fulled =
          res.questM.questMaxNum != null &&
          res.questM.questMaxNum <= res.questM.questNowNum

        // [Debug]
        // window.console.log('timeStart: ' + timeStart)
        // window.console.log('timeEnd: ' + timeEnd)
        // window.console.log('Expired: ' + Expired)
        // window.console.log('fulled: ' + fulled)
        // window.console.log('isVisible: ' + res.questM.isVisible)

        // 判斷是否可以顯示
        if (res.questM.isVisible !== '01') {
          // 1. 是否公開 isVisible
          this.$router.push({ name: 'Private', query })
        } else if (Expired) {
          // 2. 是否於可顯示之日期區間
          this.$router.push({ name: 'Expired', query })
        } else if (fulled) {
          // 3. 判斷是否有設定填寫名額，且填寫人數已額滿
          this.$router.push({ name: 'Fulled', query })
        } else {
          initDetailLogic(res)
          // 跳至回答頁面
          this.$router.push({ name: 'Answer', query })
        }
      })
      .catch(err => {
        this.$store.state.errMessage = err
        this.$router.push({ name: 'ErrorPage', query })
      })
      */
  },
  methods: {
    onResize() {
      this.$store.state.isMobile = window.innerWidth < 800
    },
  },
  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  beforeDestroy() {
    if (typeof window === 'undefined') return
    window.removeEventListener('resize', this.onResize, { passive: true })
  },
}
</script>

<style lang="scss"></style>
